import './ScenarioItem_styles.scss';

interface ScenarioItemProps {
    id: string;
    name: string;
    description: string;
    scenarioContentKey: string;
    isLoading: boolean;
    onClick(id: string): void;
}

const ScenarioItem = ({ id, name, isLoading, onClick }: ScenarioItemProps) => (
    <div className='ScenarioItem'>
        <div className='ScenarioItem__content'>
            <p className='ScenarioItem__name'>{name}</p>
            <p className='ScenarioItem__id'>
                <span className='ScenarioItem__id-label'>id:</span> {id}
            </p>
            <div className='ScenarioItem__actions'>
                <button disabled={isLoading} onClick={() => onClick(id)} className='ScenarioItem__delete-button'>
                    <span className='rioglyph rioglyph-trash ScenarioItem__delete-button-icon' />
                </button>
            </div>
        </div>
    </div>
);

export default ScenarioItem;
